import { useState } from "react"
import { useNavigate, Link } from "react-router-dom"
import Swal from "sweetalert2"
import Header from "../components/Header"
import Footer from "../components/Footer"

import { API_BASE_URL } from "../config/apiConfig"

const SaleteamForgotPassword = () => {
  const navigate = useNavigate()
  const [step, setStep] = useState(1) // 1 = request OTP, 2 = reset password
  const [email, setEmail] = useState("")
  const [otp, setOtp] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [showPassword, setShowPassword] = useState(false)
  const [loading, setLoading] = useState(false)

  const handleRequestOTP = async (e) => {
    e.preventDefault()
    if (!email) return

    setLoading(true)
    try {
      const response = await fetch(`${API_BASE_URL}/users/salesman/forgot-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      })
      const data = await response.json()

      if (data.success) {
        Swal.fire({
          icon: "success",
          title: "OTP Sent",
          text: data.message || "Please check your email for the OTP.",
          timer: 2000,
          showConfirmButton: false,
        })
        setStep(2)
      } else {
        Swal.fire({
          icon: "error",
          title: "Request Failed",
          text: data.message || "Could not process request.",
        })
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Connection Error",
        text: "Could not connect to server. Please try again.",
      })
    } finally {
      setLoading(false)
    }
  }

  const handleResetPassword = async (e) => {
    e.preventDefault()
    if (!otp || !newPassword || !confirmPassword) return

    if (newPassword !== confirmPassword) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "New passwords do not match.",
      })
      return
    }

    if (newPassword.length < 8) {
      Swal.fire({
        icon: "error",
        title: "Validation Error",
        text: "Password must be at least 8 characters long.",
      })
      return
    }

    setLoading(true)
    try {
      const response = await fetch(`${API_BASE_URL}/users/salesman/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, otp, newPassword }),
      })
      const data = await response.json()

      if (data.success) {
        Swal.fire({
          icon: "success",
          title: "Password Reset!",
          text: data.message || "Your password has been updated successfully.",
          timer: 2000,
          showConfirmButton: false,
        })
        setTimeout(() => {
          navigate("/saleteam-login")
        }, 2000)
      } else {
        Swal.fire({
          icon: "error",
          title: "Reset Failed",
          text: data.message || "Invalid OTP or request expired.",
        })
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Connection Error",
        text: "Could not connect to server. Please try again.",
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <>
      <Header />
      <section className="hero" style={{ minHeight: "100vh", paddingTop: "100px" }}>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-5 mt-5">
              <div className="card border-0 shadow position-relative" style={{ borderRadius: "30px", overflow: "visible" }}>
                {/* Circular Icon Overlap */}
                <div 
                  className="position-absolute top-0 start-50 translate-middle shadow" 
                  style={{ 
                    width: "100px", 
                    height: "100px", 
                    backgroundColor: "#00B5AD", 
                    borderRadius: "50%", 
                    display: "flex", 
                    alignItems: "center", 
                    justifyContent: "center",
                    border: "5px solid #fff",
                    zIndex: "10"
                  }}
                >
                  <i className="bi bi-shield-lock-fill text-white" style={{ fontSize: "3rem" }}></i>
                </div>

                <div className="card-body p-5 pt-5 mt-4">
                  <div className="text-center mb-4 mt-2">
                    <h4 className="fw-bold" style={{ color: "#002B5C" }}>Password Reset</h4>
                    <p className="text-muted small mt-1 mb-0">
                      {step === 1 ? "Enter your registered email to receive an OTP" : `Enter the OTP sent to ${email}`}
                    </p>
                  </div>

                  {step === 1 ? (
                    <form onSubmit={handleRequestOTP}>
                      <div className="mb-4">
                        <div className="input-group">
                          <span className="input-group-text border-0" style={{ backgroundColor: "#f0f2f5", borderRadius: "50px 0 0 50px", paddingLeft: "20px" }}>
                            <i className="bi bi-envelope-fill text-muted"></i>
                          </span>
                          <input
                            type="email"
                            className="form-control border-0"
                            placeholder="Enter your email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                            style={{ backgroundColor: "#f0f2f5", borderRadius: "0 50px 50px 0", height: "50px", boxShadow: "none" }}
                          />
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-turquoise w-100 rounded-pill fw-bold text-uppercase"
                        disabled={loading}
                        style={{ height: "50px", fontSize: "1rem", letterSpacing: "1px" }}
                      >
                        {loading ? <span className="spinner-border spinner-border-sm"></span> : "Send OTP"}
                      </button>

                      <div className="text-center mt-4">
                        <Link to="/saleteam-login" className="text-muted small text-decoration-none">
                          <i className="bi bi-arrow-left me-1"></i> Back to Login
                        </Link>
                      </div>
                    </form>
                  ) : (
                    <form onSubmit={handleResetPassword}>
                      <div className="mb-3">
                        <div className="input-group">
                          <span className="input-group-text border-0" style={{ backgroundColor: "#f0f2f5", borderRadius: "50px 0 0 50px", paddingLeft: "20px" }}>
                            <i className="bi bi-key-fill text-muted"></i>
                          </span>
                          <input
                            type="text"
                            className="form-control border-0"
                            placeholder="6-digit OTP Code"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                            required
                            style={{ backgroundColor: "#f0f2f5", borderRadius: "0 50px 50px 0", height: "50px", boxShadow: "none" }}
                          />
                        </div>
                      </div>

                      <div className="mb-3">
                        <div className="input-group position-relative">
                          <span className="input-group-text border-0" style={{ backgroundColor: "#f0f2f5", borderRadius: "50px 0 0 50px", paddingLeft: "20px" }}>
                            <i className="bi bi-lock-fill text-muted"></i>
                          </span>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control border-0"
                            placeholder="New Password (min 8 chars)"
                            value={newPassword}
                            onChange={(e) => setNewPassword(e.target.value)}
                            required
                            style={{ backgroundColor: "#f0f2f5", borderRadius: "0 50px 50px 0", height: "50px", boxShadow: "none", paddingRight: "50px" }}
                          />
                          <button
                            type="button"
                            className="btn position-absolute top-50 end-0 translate-middle-y border-0 pe-4"
                            onClick={() => setShowPassword(!showPassword)}
                            style={{ zIndex: 10, background: "transparent" }}
                            tabIndex="-1"
                          >
                            <i className={`bi ${showPassword ? "bi-eye-slash-fill" : "bi-eye-fill"} text-muted`}></i>
                          </button>
                        </div>
                      </div>

                      <div className="mb-4">
                        <div className="input-group position-relative">
                          <span className="input-group-text border-0" style={{ backgroundColor: "#f0f2f5", borderRadius: "50px 0 0 50px", paddingLeft: "20px" }}>
                            <i className="bi bi-check-circle-fill text-muted"></i>
                          </span>
                          <input
                            type={showPassword ? "text" : "password"}
                            className="form-control border-0"
                            placeholder="Confirm New Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                            required
                            style={{ backgroundColor: "#f0f2f5", borderRadius: "0 50px 50px 0", height: "50px", boxShadow: "none", paddingRight: "50px" }}
                          />
                        </div>
                      </div>

                      <button
                        type="submit"
                        className="btn btn-turquoise w-100 rounded-pill fw-bold text-uppercase"
                        disabled={loading}
                        style={{ height: "50px", fontSize: "1rem", letterSpacing: "1px" }}
                      >
                        {loading ? <span className="spinner-border spinner-border-sm"></span> : "Reset Password"}
                      </button>

                      <div className="text-center mt-4">
                        <button
                          type="button"
                          className="btn btn-link text-muted small text-decoration-none p-0 me-3"
                          onClick={() => setStep(1)}
                        >
                          <i className="bi bi-arrow-left me-1"></i> Change Email
                        </button>
                        <Link to="/saleteam-login" className="text-muted small text-decoration-none">
                          Back to Login
                        </Link>
                      </div>
                    </form>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  )
}

export default SaleteamForgotPassword
